// test261
(261 && 0);
